"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductList = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const hooks_1 = require("../../hooks");
const client_utils_1 = require("../../../../client/client.utils");
const table_pagination_1 = require("../../../../common/table-pagination");
const hooks_2 = require("../../../../hooks");
const product_table_dynamic_columns_1 = require("../../../../hooks/product-table-dynamic-columns");
const products_table_1 = require("../../../../store/catalogs/products-table");
const store_1 = require("../../../../../store");
const PRODUCT_LIST_ROW_CHUNK_SIZE = 250;
const useProductList = (isListViewMode) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const searchTerm = (0, products_table_1.useProductsTableSearch)();
    const tableFilter = (0, products_table_1.useProductsTableFilter)();
    const tableSort = (0, products_table_1.useProductsTableSortOrDefault)();
    const pageSize = (0, products_table_1.useProductsTablePageSize)();
    const persistedState = (0, react_1.useMemo)(() => ({ pageSize }), [pageSize]);
    const initialModel = (0, react_1.useMemo)(() => ({ page: 0, pageSize }), [pageSize]);
    const setPersistedState = (paginationModel) => {
        if (paginationModel.pageSize !== pageSize) {
            dispatch((0, products_table_1.setProductsTablePageSize)(catalogId, paginationModel.pageSize));
        }
    };
    const selectedProductTreeNode = (0, hooks_2.useSelectedTreeNode)();
    const { id: selectedStrategyNodeId } = selectedProductTreeNode !== null && selectedProductTreeNode !== void 0 ? selectedProductTreeNode : {};
    const persistedColumnsData = (0, products_table_1.useProductsTableDynamicColumns)();
    const updateGlobalState = (0, react_1.useCallback)((newData) => dispatch((0, products_table_1.setProductsDynamicTableColumns)(catalogId, newData)), [dispatch, catalogId]);
    const dynamicTableColumns = (0, product_table_dynamic_columns_1.useCustomizeTableColumns)({
        options: {
            persisted: true,
            persistedTableData: persistedColumnsData,
            setPersistedTableData: updateGlobalState,
        },
    });
    const selectedAttributeNode = (0, store_1.useSelectedAttributeNode)();
    const { products, isLoading, networkStatus, totalCount, refetch, pageInfo, error, chunkLoadError, chunkLoadErrorProductCount, canRetryChunkLoad, retryChunkLoad, lockedProductsCount, lastVariables, isPageRowsSyncing, arePageRowsIncomplete, } = (0, hooks_1.useProducts)({
        tableFilter,
        tableSort,
        searchTerm,
        isListViewMode,
        labelsSelection: dynamicTableColumns,
        productTreeNodeId: selectedStrategyNodeId,
        pageSize,
        selectedAttributeNode,
        chunkSize: PRODUCT_LIST_ROW_CHUNK_SIZE,
        includeLabelExplanation: false,
        // For terminal nodes, missing strategy values are always represented as Unknown,
        // so we can skip label validation payload to reduce query size.
        skipLabelValidation: !!(selectedProductTreeNode === null || selectedProductTreeNode === void 0 ? void 0 : selectedProductTreeNode.isTerminalNode),
    });
    const { isPaginationRefetching, paginationRefetch, } = (0, table_pagination_1.usePaginationRefetch)({ refetch });
    const { paginationModel, onPaginationModelChange, } = (0, table_pagination_1.useOffsetCursorPaginationAdapter)({
        refetch: paginationRefetch,
        totalCount,
        startCursor: pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.startCursor,
        initialModel,
        persistedState,
        setPersistedState,
    });
    return {
        products,
        // Show the loader for initial load and variable changes, but not for background mutation refetches.
        // Pagination uses refetch under the hood, so keep a local flag for user-triggered page changes.
        isLoading: (isLoading && !(0, client_utils_1.isQueryRefetching)(networkStatus)) || isPaginationRefetching,
        isPageRowsSyncing,
        arePageRowsIncomplete,
        paginationModel,
        onPaginationModelChange,
        networkStatus,
        error,
        chunkLoadError,
        chunkLoadErrorProductCount,
        canRetryChunkLoad,
        retryChunkLoad,
        totalCount,
        lockedProductsCount,
        lastVariables: lastVariables,
    };
};
exports.useProductList = useProductList;
